import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SelectOption } from '@shared/components/multi-select/models';
import { DataFilterForm } from './models/table';
import { SortingType } from '../../../data/modules/catalog-data/components/ordering/models';

@Injectable({
  providedIn: 'root'
})
export class DataState {
  public filterForm = new BehaviorSubject<DataFilterForm>({
    newRecommendedFavorites: false,
    datasetType: null,
    activeStatus: true,
    archiveStatus: false,
    accessibility: false,
    summerSeason: false,
    winterSeason: false,
    allSeasons: false,
    withMap: false,
    withoutMap: false,
    iso: false,
    ordinaryDict: false,
    regionalDict: false,
    federalDict: false
  });

  public sorting = new BehaviorSubject<SortingType>({ byNameCatalog: 'ASC' });

  public categories = new BehaviorSubject<SelectOption[]>([]);
  public providers = new BehaviorSubject<SelectOption[]>([]);

  public setDefaultFilterForm(): void {
    this.filterForm.next({
      newRecommendedFavorites: false,
      datasetType: null,
      activeStatus: true,
      archiveStatus: false,
      accessibility: false,
      summerSeason: false,
      winterSeason: false,
      allSeasons: false,
      withMap: false,
      withoutMap: false,
      iso: false,
      ordinaryDict: false,
      regionalDict: false,
      federalDict: false
    });
  }
}
